<template>
  <div class="ChangePasswordView container">
    <h1
      class="ChangePasswordView__heading flex items-center font-family-display font-weight-bold mb-48 flex"
    >
      <router-link
        :to="{ name: 'WelcomeView' }"
        class="color-black font-size-xxl mr-16"
      >
        <span class="icon-simple-arrow-left"></span>
      </router-link>
      {{ $t('change_password') }}
    </h1>
    <div class="ChangePasswordView__form-container">
      <ChangePasswordForm is-profile :loading="loading" @send-form="sendForm" />
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import ChangePasswordForm from '@/components/forms/ChangePasswordForm.vue'
import { useUserStore } from '@/stores/userStore'
import { useNotificationsStore } from '@/stores/notificationsStore'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'

const loading = ref(false)

const router = useRouter()
const { t } = useI18n()

const { changePassword } = useUserStore()
const { setNotification } = useNotificationsStore()

async function sendForm(form) {
  try {
    loading.value = true
    await changePassword(form)
    setNotification({
      header: t('change_password_success'),
      body: t('profile_edited_successfully'),
      type: 'success'
    })
    await router.push({ name: 'ProfileView' })
  } catch (e) {
    setNotification({
      header: t('account_common_error'),
      body: 'It looks like an error occurred while trying to change the password. Check the data is correct or try again later.',
      type: 'danger'
    })
  } finally {
    loading.value = true
  }
}
</script>

<style lang="scss" scoped>
.ChangePasswordView {
  &__form-container {
    margin: auto;
    max-width: 100%;
    width: rem(588);
  }
}
</style>
